import { useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'
import AuthShell, { Field, SubmitButton } from '@/components/AuthShell'

export default function ResetPassword({ token }: { token: string }) {
  const form = useForm({ password: '', password_confirmation: '' })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.patch(`/passwords/${token}`)
  }

  return (
    <AuthShell title="重置密码" subtitle="设置一个新密码。">
      <form onSubmit={submit} className="grid gap-4">
        <Field
          label="新密码"
          type="password"
          autoComplete="new-password"
          autoFocus
          required
          maxLength={72}
          placeholder="至少 8 位"
          value={form.data.password}
          error={form.errors.password}
          onChange={(e) => form.setData('password', e.target.value)}
        />
        <Field
          label="确认新密码"
          type="password"
          autoComplete="new-password"
          required
          maxLength={72}
          value={form.data.password_confirmation}
          error={form.errors.password_confirmation}
          onChange={(e) => form.setData('password_confirmation', e.target.value)}
        />
        <SubmitButton disabled={form.processing}>{form.processing ? '提交中…' : '重置密码'}</SubmitButton>
      </form>
    </AuthShell>
  )
}
